export interface Lender {
  id: string;
  name: string;
  shortName: string;
  logo: string;
  description: string;
  features: string[];
  loanTypes: string[];
  highlights?: {
    label: string;
    value: string;
  }[];
  website?: string;
}

export const lenders: Lender[] = [
  {
    id: "commbank",
    name: "Commonwealth Bank of Australia",
    shortName: "CommBank",
    logo: "/lenders/commbank.png",
    description:
      "Australia's largest bank offering comprehensive home loan solutions with competitive rates and flexible features.",
    features: [
      "Offset accounts available",
      "Redraw facility",
      "Split loan options",
      "Construction loan specialists",
      "First home buyer packages",
    ],
    loanTypes: ["Variable", "Fixed", "Split", "Construction", "Investment"],
    highlights: [
      { label: "Loan Types", value: "15+" },
      { label: "Max LVR", value: "95%" },
    ],
  },
  {
    id: "westpac",
    name: "Westpac Banking Corporation",
    shortName: "Westpac",
    logo: "/lenders/westpac.png",
    description:
      "One of Australia's big four banks with a strong focus on customer service and innovative banking solutions.",
    features: [
      "Flexi First Option for first home buyers",
      "Package discounts available",
      "Offset sub-accounts",
      "Rate lock option",
      "Online application tracking",
    ],
    loanTypes: ["Variable", "Fixed", "Package", "Investment", "Construction"],
    highlights: [
      { label: "Rate Lock", value: "90 days" },
      { label: "Max LVR", value: "95%" },
    ],
  },
  {
    id: "nab",
    name: "National Australia Bank",
    shortName: "NAB",
    logo: "/lenders/nab.png",
    description:
      "Trusted Australian bank known for competitive rates and tailored lending solutions for all borrower types.",
    features: [
      "NAB Tailored Home Loan",
      "No monthly fees options",
      "Extra repayments allowed",
      "Redraw available",
      "Professional packages",
    ],
    loanTypes: ["Variable", "Fixed", "Interest Only", "Investment"],
    highlights: [
      { label: "Extra Repay", value: "Unlimited" },
      { label: "Offset", value: "100%" },
    ],
  },
  {
    id: "ing",
    name: "ING Australia",
    shortName: "ING",
    logo: "/lenders/ing.png",
    description:
      "Digital-first bank offering some of the most competitive rates in the market with no ongoing fees.",
    features: [
      "No ongoing monthly fees",
      "Competitive low rates",
      "Unlimited free redraw",
      "Extra repayments welcome",
      "100% offset account",
    ],
    loanTypes: ["Variable", "Fixed", "Investment"],
    highlights: [
      { label: "Monthly Fee", value: "$0" },
      { label: "Redraw", value: "Free" },
    ],
  },
  {
    id: "macquarie",
    name: "Macquarie Bank",
    shortName: "Macquarie",
    logo: "/lenders/macquarie.png",
    description:
      "Australia's leading investment bank now offering competitive home loans with premium service.",
    features: [
      "Offset account included",
      "Flexible repayment options",
      "Rate match guarantee",
      "Dedicated relationship manager",
      "No application fees",
    ],
    loanTypes: ["Variable", "Fixed", "Investment", "SMSF"],
    highlights: [
      { label: "App Fee", value: "$0" },
      { label: "Rate Match", value: "Yes" },
    ],
  },
  {
    id: "suncorp",
    name: "Suncorp Bank",
    shortName: "Suncorp",
    logo: "/lenders/suncorp.png",
    description:
      "Queensland-based bank offering friendly service and competitive home loan products Australia-wide.",
    features: [
      "Back to Basics low rate",
      "Family Pledge available",
      "Green home loan discounts",
      "Construction lending",
      "No ongoing fees options",
    ],
    loanTypes: ["Variable", "Fixed", "Construction", "Green Loans"],
    highlights: [
      { label: "Green Discount", value: "0.30%" },
      { label: "Pledge", value: "Yes" },
    ],
  },
  {
    id: "bankwest",
    name: "Bankwest",
    shortName: "Bankwest",
    logo: "/lenders/bankwest.png",
    description:
      "Part of the CBA group, Bankwest offers competitive rates and a streamlined digital lending experience.",
    features: [
      "Complete Package savings",
      "Fast online approvals",
      "Flexible offset options",
      "Low deposit options",
      "Rate lock available",
    ],
    loanTypes: ["Variable", "Fixed", "Package", "Investment"],
    highlights: [
      { label: "Package", value: "0.25% off" },
      { label: "Approval", value: "Fast" },
    ],
  },
  {
    id: "boq",
    name: "Bank of Queensland",
    shortName: "BOQ",
    logo: "/lenders/boq.png",
    description:
      "Regional bank with a personal touch, offering tailored solutions through local owner-managers.",
    features: [
      "Clear Path variable loan",
      "Economy Plus low rate",
      "Local branch support",
      "First home saver accounts",
      "Offset available",
    ],
    loanTypes: ["Variable", "Fixed", "First Home", "Investment"],
    highlights: [
      { label: "Service", value: "Local" },
      { label: "Offset", value: "100%" },
    ],
  },
  {
    id: "st-george",
    name: "St.George Bank",
    shortName: "St.George",
    logo: "/lenders/st-george.webp",
    description:
      "Part of Westpac Group, St.George combines big bank stability with a focus on personal service.",
    features: [
      "Advantage Package discounts",
      "Flexible repayment options",
      "Offset account included",
      "Construction lending",
      "Investment specialists",
    ],
    loanTypes: ["Variable", "Fixed", "Package", "Construction"],
    highlights: [
      { label: "Package", value: "Discounts" },
      { label: "Offset", value: "Included" },
    ],
  },
];

export const lenderStats = {
  totalLenders: "70+",
  majorBanks: "All 4",
  approvalTime: "24-48hrs",
  noFees: "Free",
};
